import { LOANS_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    loansOwnToMe: [],
    loansOwnToOthers: [],
    loansOwnToMeLoading: false,
    loansOwnToMeSuccess: false,
    loansOwnToMeFailure: false,
    loansOwnToMeError: null,
    loansOwnToOthersLoading: false,
    loansOwnToOthersSuccess: false,
    loansOwnToOthersFailure: false,
    loansOwnToOthersError: null,
    addLoanLoading: false,
    addLoanSuccess: false,
    addLoanFailure: false,
    addLoanError: null
}

export const loanReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOANS_REQUEST.GET_LOANS_OWN_TO_ME_REQUEST:
            return {
                ...state,
                loansOwnToMeLoading: true,
                loansOwnToMeSuccess: false,
                loansOwnToMeFailure: false,
                loansOwnToMeError: null
            }
        case LOANS_REQUEST.GET_LOANS_OWN_TO_ME_SUCCESS:
            return {
                ...state,
                loansOwnToMeLoading: false,
                loansOwnToMeSuccess: true,
                loansOwnToMeFailure: false,
                loansOwnToMeError: null,
                loansOwnToMe: action.payload
            }
        case LOANS_REQUEST.GET_LOANS_OWN_TO_ME_FAILURE:
            return {
                ...state,
                loansOwnToMeLoading: false,
                loansOwnToMeSuccess: false,
                loansOwnToMeFailure: true,
                loansOwnToMeError: action.payload
            }
        case LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_REQUEST:
            return {
                ...state,
                loansOwnToOthersLoading: true,
                loansOwnToOthersSuccess: false,
                loansOwnToOthersFailure: false,
                loansOwnToOthersError: null
            }
        case LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_SUCCESS:
            return {
                ...state,
                loansOwnToOthersLoading: false,
                loansOwnToOthersSuccess: true,
                loansOwnToOthersFailure: false,
                loansOwnToOthersError: null,
                loansOwnToOthers: action.payload
            }
        case LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_FAILURE:
            return {
                ...state,
                loansOwnToOthersLoading: false,
                loansOwnToOthersSuccess: false,
                loansOwnToOthersFailure: true,
                loansOwnToOthersError: action.payload
            }
        case LOANS_REQUEST.ADD_LOAN_REQUEST:
            return {
                ...state,
                addLoanLoading: true,
                addLoanSuccess: false,
                addLoanFailure: false,
                addLoanError: null
            }
        case LOANS_REQUEST.ADD_LOAN_SUCCESS:
            let newLoanList = []
            if (action.payload.loanType === "I owe to others") {
                newLoanList = state.loansOwnToOthers;
                action.payload = { ...action.payload, id: state.loansOwnToOthers.length }
                newLoanList.push(action.payload)
                return {
                    ...state,
                    addLoanLoading: false,
                    addLoanSuccess: true,
                    addLoanFailure: false,
                    addLoanError: null,
                    loansOwnToOthers: newLoanList
                }
            }
            else {
                action.payload = { ...action.payload, id: state.loansOwnToOthers.length }
                newLoanList = state.loansOwnToMe;
                newLoanList.push(action.payload)
                return {
                    ...state,
                    addLoanLoading: false,
                    addLoanSuccess: true,
                    addLoanFailure: false,
                    addLoanError: null,
                    loansOwnToMe: newLoanList
                }
            }
        case LOANS_REQUEST.ADD_LOAN_FAILURE:
            return {
                ...state,
                addLoanLoading: false,
                addLoanSuccess: false,
                addLoanFailure: true,
                addLoanError: action.payload
            }
        case LOANS_REQUEST.DELETE_LOAN_REQUEST:
            return {
                ...state,
                addLoanLoading: true,
                addLoanSuccess: false,
                addLoanFailure: false,
                addLoanError: null
            }
        case LOANS_REQUEST.DELETE_LOAN_SUCCESS:
            let newLoanList_ = []
            if (action.payload.loanType === "I owe to others") {
                newLoanList_ = state.loansOwnToOthers;
                for (var i = 0; i < newLoanList_.length; i++) {
                    if (newLoanList_[i].id === action.payload.loanId) {
                        newLoanList_.splice(i, 1)
                    }
                }
                return {
                    ...state,
                    addLoanLoading: false,
                    addLoanSuccess: true,
                    addLoanFailure: false,
                    addLoanError: null,
                    loansOwnToOthers: newLoanList_
                }
            }
            else {
                newLoanList_ = state.loansOwnToMe;
                for (var i = 0; i < newLoanList_.length; i++) {
                    if (newLoanList_[i].id === action.payload.loanId) {
                        newLoanList_.splice(i, 1)
                    }
                }
                return {
                    ...state,
                    addLoanLoading: false,
                    addLoanSuccess: true,
                    addLoanFailure: false,
                    addLoanError: null,
                    loansOwnToMe: newLoanList_
                }
            }
        case LOANS_REQUEST.DELETE_LOAN_FAILURE:
            return {
                ...state,
                addLoanLoading: false,
                addLoanSuccess: false,
                addLoanFailure: true,
                addLoanError: action.payload
            }
        case LOANS_REQUEST.EDIT_LOAN_REQUEST:
            return {
                ...state,
                addLoanLoading: true,
                addLoanSuccess: false,
                addLoanFailure: false,
                addLoanError: null
            }
        case LOANS_REQUEST.EDIT_LOAN_SUCCESS:
            let LoanList_ = []
            if (action.payload.loanType === "I owe to others") {
                LoanList_ = state.loansOwnToOthers;
                for (var i = 0; i < LoanList_.length; i++) {
                    if (LoanList_[i].id === action.payload.id) {
                        LoanList_[i] = action.payload
                    }
                }
                return {
                    ...state,
                    addLoanLoading: false,
                    addLoanSuccess: true,
                    addLoanFailure: false,
                    addLoanError: null,
                    loansOwnToOthers: LoanList_
                }
            }
            else {
                LoanList_ = state.loansOwnToMe;
                for (var i = 0; i < LoanList_.length; i++) {
                    if (LoanList_[i].id === action.payload.id) {
                        LoanList_[i] = action.payload
                    }
                }
                return {
                    ...state,
                    addLoanLoading: false,
                    addLoanSuccess: true,
                    addLoanFailure: false,
                    addLoanError: null,
                    loansOwnToMe: LoanList_
                }
            }
        case LOANS_REQUEST.EDIT_LOAN_FAILURE:
            return {
                ...state,
                addLoanLoading: false,
                addLoanSuccess: false,
                addLoanFailure: true,
                addLoanError: action.payload
            }
        default:
            return state
    }
}
